import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import SBProBorder from '@structural/border.vue';
let SBProPageSection = class SBProPageSection extends Vue {
};
__decorate([
    Prop()
], SBProPageSection.prototype, "sectionClasses", void 0);
__decorate([
    Prop()
], SBProPageSection.prototype, "borderType", void 0);
__decorate([
    Prop({ default: 'text-white' })
], SBProPageSection.prototype, "borderClasses", void 0);
__decorate([
    Prop()
], SBProPageSection.prototype, "backgroundImage", void 0);
SBProPageSection = __decorate([
    Component({
        components: {
            'sbpro-border': SBProBorder,
        },
    })
], SBProPageSection);
export default SBProPageSection;
